import { langRouteI18n } from '@bcf-v2/routes/common/app/i18n/lang-route-i18n';
import { esportRouteI18n } from '../i18n/esport-route-i18n';

export function esportRoutePath(): string {
  return `/${langRouteI18n()}/${esportRouteI18n()}`;
}
